import React, { useState } from "react";
import { Link } from "react-router-dom";

import "../walletTabs/WalletModal.css";

const WalletModal = () => {
  const [selectedSugarType, setSelectedSugarType] = useState("Sugar Daddy");
  return (
    <div className="modal-payment-all-option">
      <div
        class="modal fade modal-payment-option"
        id="exampleModalToggle"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabindex="-1"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title " id="exampleModalToggleLabel">
                Add New Payment Method
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="32" height="32" rx="16" fill="#F1F1F1" />
                  <path
                    d="M22.3007 9.71C21.9107 9.32 21.2807 9.32 20.8907 9.71L16.0007 14.59L11.1107 9.7C10.7207 9.31 10.0907 9.31 9.7007 9.7C9.3107 10.09 9.3107 10.72 9.7007 11.11L14.5907 16L9.7007 20.89C9.3107 21.28 9.3107 21.91 9.7007 22.3C10.0907 22.69 10.7207 22.69 11.1107 22.3L16.0007 17.41L20.8907 22.3C21.2807 22.69 21.9107 22.69 22.3007 22.3C22.6907 21.91 22.6907 21.28 22.3007 20.89L17.4107 16L22.3007 11.11C22.6807 10.73 22.6807 10.09 22.3007 9.71Z"
                    fill="#301E39"
                  />
                </svg>
              </button>
            </div>
            <div class="modal-body">
              <div className="payment-option-sec">
                <h2>Select Method</h2>
                <div className="payment-box d-flex align-items-center justify-content-between gap-3 mb-2">
                  <div className="left-payment-option d-flex align-items-center gap-2">
                    <div className="payment-img">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="32" height="32" rx="10" fill="#FD59D9" />
                        <g clip-path="url(#clip0_149_6089)">
                          <path
                            d="M22.666 9.33331H9.33268C8.40768 9.33331 7.67435 10.075 7.67435 11L7.66602 21C7.66602 21.925 8.40768 22.6666 9.33268 22.6666H22.666C23.591 22.6666 24.3327 21.925 24.3327 21V11C24.3327 10.075 23.591 9.33331 22.666 9.33331ZM22.666 21H9.33268V16H22.666V21ZM22.666 12.6666H9.33268V11H22.666V12.6666Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_149_6089">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(6 6)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="payment-text">
                      <h3>Debit/Credit Card</h3>
                    </div>
                  </div>
                  <div className="payment-radio-option">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="sugarType"
                        id="sugarDaddy"
                        value="Sugar Daddy"
                        checked={selectedSugarType === "Sugar Daddy"}
                        onChange={() => setSelectedSugarType("Sugar Daddy")}
                      />
                      <label
                        htmlFor="sugarDaddy"
                        className="form-check-label"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="payment-box d-flex align-items-center justify-content-between gap-3 mb-2">
                  <div className="left-payment-option d-flex align-items-center gap-2">
                    <div className="payment-img">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="32" height="32" rx="10" fill="#35B4DC" />
                        <g clip-path="url(#clip0_149_6093)">
                          <path
                            d="M22.666 11H20.8493C20.941 10.7417 20.9993 10.4584 20.9993 10.1667C20.9993 8.78335 19.8827 7.66669 18.4993 7.66669C17.6243 7.66669 16.866 8.11669 16.416 8.79169L15.9993 9.35002L15.5827 8.78335C15.1327 8.11669 14.3743 7.66669 13.4993 7.66669C12.116 7.66669 10.9993 8.78335 10.9993 10.1667C10.9993 10.4584 11.0577 10.7417 11.1493 11H9.33268C8.40768 11 7.67435 11.7417 7.67435 12.6667L7.66602 21.8334C7.66602 22.7584 8.40768 23.5 9.33268 23.5H22.666C23.591 23.5 24.3327 22.7584 24.3327 21.8334V12.6667C24.3327 11.7417 23.591 11 22.666 11ZM18.4993 9.33335C18.9577 9.33335 19.3327 9.70835 19.3327 10.1667C19.3327 10.625 18.9577 11 18.4993 11C18.041 11 17.666 10.625 17.666 10.1667C17.666 9.70835 18.041 9.33335 18.4993 9.33335ZM13.4993 9.33335C13.9577 9.33335 14.3327 9.70835 14.3327 10.1667C14.3327 10.625 13.9577 11 13.4993 11C13.041 11 12.666 10.625 12.666 10.1667C12.666 9.70835 13.041 9.33335 13.4993 9.33335ZM22.666 21.8334H9.33268V20.1667H22.666V21.8334ZM22.666 17.6667H9.33268V12.6667H13.566L11.8327 15.025L13.1827 16L15.9993 12.1667L18.816 16L20.166 15.025L18.4327 12.6667H22.666V17.6667Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_149_6093">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(6 6)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="payment-text">
                      <h3>Visa</h3>
                    </div>
                  </div>
                  <div className="payment-radio-option">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="sugarType"
                        id="payment2"
                        value="Sugar Daddy"
                        checked={selectedSugarType === "Sugar Daddy"}
                        onChange={() => setSelectedSugarType("Sugar Daddy")}
                      />
                      <label
                        htmlFor="payment2"
                        className="form-check-label"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="payment-box d-flex align-items-center justify-content-between gap-3 mb-2">
                  <div className="left-payment-option d-flex align-items-center gap-2">
                    <div className="payment-img">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="32" height="32" rx="10" fill="#86C23A" />
                        <g clip-path="url(#clip0_149_6097)">
                          <path
                            d="M15.9993 7.66669C11.3993 7.66669 7.66602 11.4 7.66602 16C7.66602 20.6 11.3993 24.3334 15.9993 24.3334C20.5993 24.3334 24.3327 20.6 24.3327 16C24.3327 11.4 20.5993 7.66669 15.9993 7.66669ZM15.9993 22.6667C12.3243 22.6667 9.33268 19.675 9.33268 16C9.33268 12.325 12.3243 9.33335 15.9993 9.33335C19.6743 9.33335 22.666 12.325 22.666 16C22.666 19.675 19.6743 22.6667 15.9993 22.6667ZM16.2577 15.2834C14.7827 14.9084 14.3077 14.5 14.3077 13.8917C14.3077 13.1917 14.966 12.7 16.0577 12.7C17.2077 12.7 17.641 13.25 17.6743 14.0667H19.0993C19.0577 12.95 18.3743 11.925 17.0243 11.5917V10.1667H15.0827V11.575C13.8243 11.8417 12.816 12.6584 12.816 13.9167C12.816 15.4084 14.0577 16.1584 15.866 16.5917C17.491 16.975 17.816 17.55 17.816 18.15C17.816 18.5917 17.491 19.3084 16.066 19.3084C14.7327 19.3084 14.2077 18.7084 14.1327 17.9417H12.6993C12.7827 19.3584 13.8327 20.1584 15.0827 20.4167V21.8334H17.0327V20.4417C18.2993 20.2 19.2993 19.475 19.3077 18.1334C19.2993 16.3 17.7243 15.6667 16.2577 15.2834Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_149_6097">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(6 6)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="payment-text">
                      <h3>Google Pay</h3>
                    </div>
                  </div>
                  <div className="payment-radio-option">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="sugarType"
                        id="payment3"
                        value="Sugar Daddy"
                        checked={selectedSugarType === "Sugar Daddy"}
                        onChange={() => setSelectedSugarType("Sugar Daddy")}
                      />
                      <label
                        htmlFor="payment3"
                        className="form-check-label"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="payment-box d-flex align-items-center justify-content-between gap-3 mb-2">
                  <div className="left-payment-option d-flex align-items-center gap-2">
                    <div className="payment-img">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="32"
                          height="32"
                          rx="10"
                          fill="url(#paint0_linear_149_6101)"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M14.7627 11.7659H19.2755C21.6985 11.7659 22.6106 12.9926 22.4697 14.7947C22.2367 17.7699 20.4381 19.4159 18.0524 19.4159H16.8478C16.5205 19.4159 16.3003 19.6325 16.2118 20.2197L15.7004 23.6328C15.6666 23.8542 15.5501 23.9823 15.3754 23.9998H12.54C12.2733 23.9998 12.1789 23.7959 12.2488 23.3544L13.9775 12.4125C14.0451 11.9745 14.285 11.7659 14.7627 11.7659Z"
                          fill="#ADC8E0"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.94 8H16.4575C17.7296 8 19.2393 8.04077 20.2481 8.93193C20.9226 9.52719 21.2768 10.4743 21.1952 11.4947C20.918 14.944 18.8549 16.8766 16.0871 16.8766H13.8598C13.48 16.8766 13.2296 17.1282 13.1224 17.8085L12.5003 21.7692C12.4596 22.0255 12.3489 22.1769 12.1509 22.1955H9.36326C9.05455 22.1955 8.94505 21.9626 9.02543 21.4477L11.0291 8.75253C11.1094 8.2423 11.3902 8 11.94 8Z"
                          fill="white"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.1875 17.4063L13.9761 12.4123C14.0449 11.9743 14.2848 11.7646 14.7625 11.7646H19.2753C20.022 11.7646 20.6266 11.8811 21.0995 12.0966C20.6464 15.1673 18.6602 16.8728 16.0602 16.8728H13.8364C13.5381 16.8739 13.3191 17.023 13.1875 17.4063Z"
                          fill="#E6F0F6"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_149_6101"
                            x1="31"
                            y1="30.5"
                            x2="0"
                            y2="0"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#003087" />
                            <stop offset="1" stop-color="#0097D9" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div className="payment-text">
                      <h3>Paypal</h3>
                    </div>
                  </div>
                  <div className="payment-radio-option">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="sugarType"
                        id="payment4"
                        value="Sugar Daddy"
                        checked={selectedSugarType === "Sugar Daddy"}
                        onChange={() => setSelectedSugarType("Sugar Daddy")}
                      />
                      <label
                        htmlFor="payment4"
                        className="form-check-label"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="payment-box d-flex align-items-center justify-content-between gap-3 mb-2">
                  <div className="left-payment-option d-flex align-items-center gap-2">
                    <div className="payment-img">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="32" height="32" rx="10" fill="black" />
                        <g clip-path="url(#clip0_149_6105)">
                          <path
                            d="M16.6728 8.39261C17.7205 7.00706 19.1772 7.00031 19.1772 7.00031C19.1772 7.00031 19.3938 8.30295 18.3529 9.55782C17.2415 10.8977 15.9783 10.6785 15.9783 10.6785C15.9783 10.6785 15.7411 9.62468 16.6728 8.39261ZM16.1115 11.591C16.6506 11.591 17.6509 10.8476 18.9531 10.8476C21.1945 10.8476 22.0762 12.4478 22.0762 12.4478C22.0762 12.4478 20.3517 13.3325 20.3517 15.4791C20.3517 17.9006 22.5 18.7352 22.5 18.7352C22.5 18.7352 20.9982 22.9761 18.9698 22.9761C18.0381 22.9761 17.3138 22.3462 16.3321 22.3462C15.3317 22.3462 14.339 22.9996 13.6924 22.9996C11.8401 22.9997 9.5 18.9767 9.5 15.7428C9.5 12.5612 11.4808 10.8922 13.3386 10.8922C14.5464 10.8922 15.4836 11.591 16.1115 11.591Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_149_6105">
                            <rect
                              width="13"
                              height="16"
                              fill="white"
                              transform="translate(9.5 7)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="payment-text">
                      <h3>Apple Pay</h3>
                    </div>
                  </div>
                  <div className="payment-radio-option">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="sugarType"
                        id="payment5"
                        value="Sugar Daddy"
                        checked={selectedSugarType === "Sugar Daddy"}
                        onChange={() => setSelectedSugarType("Sugar Daddy")}
                      />
                      <label
                        htmlFor="payment5"
                        className="form-check-label"
                      ></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer d-flex align-items-center gap-2 justify-content-between">
              <div className="left-box">
                <Link href="" className="btn btn-primary btn-disabled">
                  Cancel
                </Link>
              </div>
              <div className="right-box">
                <Link href="" className="btn btn-primary btn-disabled">
                  Back
                </Link>
                <button
                  class="btn btn-primary"
                  data-bs-target="#exampleModalToggle2"
                  data-bs-toggle="modal"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade modal-payment-field"
        id="exampleModalToggle2"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel2"
        tabindex="-1"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title" id="exampleModalToggleLabel2">
                Add New Payment Method
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="32" height="32" rx="16" fill="#F1F1F1" />
                  <path
                    d="M22.3007 9.71C21.9107 9.32 21.2807 9.32 20.8907 9.71L16.0007 14.59L11.1107 9.7C10.7207 9.31 10.0907 9.31 9.7007 9.7C9.3107 10.09 9.3107 10.72 9.7007 11.11L14.5907 16L9.7007 20.89C9.3107 21.28 9.3107 21.91 9.7007 22.3C10.0907 22.69 10.7207 22.69 11.1107 22.3L16.0007 17.41L20.8907 22.3C21.2807 22.69 21.9107 22.69 22.3007 22.3C22.6907 21.91 22.6907 21.28 22.3007 20.89L17.4107 16L22.3007 11.11C22.6807 10.73 22.6807 10.09 22.3007 9.71Z"
                    fill="#301E39"
                  />
                </svg>
              </button>
            </div>
            <div class="modal-body">
                <div className="modal-payment-field-body">
                    <div className="top-payment-option d-flex align-items-center gap-2">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="10" fill="#FD59D9"/><g clip-path="url(#clip0_147_4059)"><path d="M22.666 9.33331H9.33268C8.40768 9.33331 7.67435 10.075 7.67435 11L7.66602 21C7.66602 21.925 8.40768 22.6666 9.33268 22.6666H22.666C23.591 22.6666 24.3327 21.925 24.3327 21V11C24.3327 10.075 23.591 9.33331 22.666 9.33331ZM22.666 21H9.33268V16H22.666V21ZM22.666 12.6666H9.33268V11H22.666V12.6666Z" fill="white"/></g><defs><clipPath id="clip0_147_4059"><rect width="20" height="20" fill="white" transform="translate(6 6)"/></clipPath></defs></svg>
                        <p>Debit/Credit Card</p>
                    </div>
                    <div className="form-body-modal">
                        <h6>Card Details</h6>
                        <form action="">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="floatingInput" placeholder="Name on Card" />
                                        <label for="floatingInput">Name on Card</label>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="floatingInput" placeholder="Card Number" />
                                        <label for="floatingInput">Card Number</label>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="floatingInput" placeholder="Card Number" />
                                        <label for="floatingInput">Card Expiry</label>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="floatingInput" placeholder="Card Number" />
                                        <label for="floatingInput">Card Expiry</label>
                                    </div>
                                </div>
                            </div>
                            
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex align-items-center gap-2 justify-content-between ">
              <div className="left-box">
                <Link href="" className="btn btn-primary btn-disabled">
                  Cancel
                </Link>
              </div>
              <div className="right-box">
                <Link
                  href=""
                  className="btn btn-primary btn-disabled"
                  data-bs-target="#exampleModalToggle"
                  data-bs-toggle="modal"
                >
                  Back
                </Link>
                <button
                  class="btn btn-primary"
                  data-bs-target="#exampleModalToggle2"
                  data-bs-toggle="modal"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletModal;
